export const INTRO_CONTENT = {
  title: "Intro Week: Start Strong",
  points: [
    "Welcome! This 27-week journey is about building sustainable habits and mindset.",
    "Your progress is saved privately on this device. You can reset anytime from the tracker.",
  ],
};

export const WEEKS = Array.from({ length: 27 }, (_, i) => {
  const n = i + 1;
  return {
    week: n,
    title: `Week ${n}: Core Focus`,
    points: [
      "This week's focus is on consistent daily actions.",
      "Full content will be added later. Keep going!",
    ],
  };
});

export const QUOTES = [
  "Small steps daily become giant leaps in hindsight.",
  "Discipline is choosing what you want most, over what you want now.",
  "Progress over perfection — keep moving forward.",
  "Your future self will thank you for today.",
];

export const WARNING_SKIP =
  "Warning: Skipping weeks can ruin your chances of success. Progression is intentional.";